<script lang="ts">
  // Choix du marché de destination (même combobox que /mundo/), avec « Tous les marchés » en tête.
  import { t } from '../lib/i18n.svelte';

  export interface Opt { iso: string; name: string; flag: string | null }
  let { options, value, onChange }: { options: Opt[]; value: string; onChange: (iso: string) => void } = $props();

  let open = $state(false);
  let q = $state('');
  let root: HTMLElement | undefined;

  const current = $derived(options.find((c) => c.iso === value) || null);
  const norm = (s: string) => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  const filtered = $derived.by(() => {
    const s = norm(q.trim());
    return (s ? options.filter((c) => norm(c.name).includes(s) || c.iso.toLowerCase().includes(s)) : options).slice(0, 120);
  });

  function pick(iso: string) { onChange(iso); open = false; q = ''; }
  function onDocClick(e: MouseEvent) { if (root && !root.contains(e.target as Node)) open = false; }
  $effect(() => {
    if (open) document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  });
</script>

<div class="picker" bind:this={root}>
  <button class="pk-btn" type="button" onclick={() => { open = !open; q = ''; }} aria-label={t('ctl.market')}>
    {#if current?.flag}<img class="mu-flag" src={current.flag} alt="" />{/if}
    <span>{current?.name || t('ctl.all')}</span>
    <i class="ti ti-chevron-down chev"></i>
  </button>
  {#if open}
    <div class="pk-pop">
      <!-- svelte-ignore a11y_autofocus -->
      <input class="pk-search" placeholder={t('ctl.search')} bind:value={q} autofocus />
      <div class="pk-list">
        {#if !q.trim()}
          <button class="pk-item" class:on={!value} type="button" onclick={() => pick('')}><span>{t('ctl.all')}</span></button>
        {/if}
        {#each filtered as c (c.iso)}
          <button class="pk-item" class:on={c.iso === value} type="button" onclick={() => pick(c.iso)}>
            {#if c.flag}<img class="mu-flag sm" src={c.flag} alt="" />{/if}
            <span>{c.name}</span>
          </button>
        {:else}
          <div class="pk-empty">{t('ctl.none')}</div>
        {/each}
      </div>
    </div>
  {/if}
</div>
